import * as React from 'react';

interface Props {
    active: boolean;
    activeKey?: string;
    children: React.ReactNode;
    anchor: string | null;
    className: string;
}

export default class PopoutMenu extends React.PureComponent<Props> {
    static defaultProps = {
        className: '',
    };

    render() {
        const { active, children, anchor, activeKey, className } = this.props;

        if (!active) {
            return null;
        }

        let classNames: Array<string> = [className, 'ddbc-popout-menu'];
        if (anchor) {
            classNames.push(`ddbc-popout-menu--anchor-${anchor}`);
        }

        return <ul className={classNames.join(' ')}>{children}</ul>;
    }
}
